import { createContext, useContext, useState } from "react";

const AlertContext = createContext()
export const useAlert = () => {
    return useContext(AlertContext)
}

// status
// 1 - success
// 2 - error
// 3 - warning

export default function AlertProvider({ children }){
    const [ alert, setAlert ] = useState({ isShow: false, status: 0, message: "" })

    function alertHandler({status, message}){
        setAlert({ isShow: true, status, message })

        const timeout = setTimeout(() => {
            setAlert({ isShow: false, status: 0, message: ""})
        }, 5000)

        return () => clearTimeout(timeout)
    }

    return (
        <AlertContext.Provider value={{ alert, setAlert, alertHandler }}>
            {children}
        </AlertContext.Provider>
    )
}